import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "@/i18n/locales/en";
import { sq } from "@/i18n/locales/sq";
import { sr } from "@/i18n/locales/sr";
import { tr } from "@/i18n/locales/tr";

export type AppLanguage = "sq" | "en" | "sr" | "tr";

const storageKey = "eshendetesia.language";

const readInitialLanguage = (): AppLanguage => {
  if (typeof window === "undefined") {
    return "sq";
  }

  const stored = window.localStorage.getItem(storageKey);
  if (stored === "sq" || stored === "en" || stored === "sr" || stored === "tr") {
    return stored;
  }

  return "sq";
};

void i18n.use(initReactI18next).init({
  resources: {
    sq: { translation: sq },
    en: { translation: en },
    sr: { translation: sr },
    tr: { translation: tr },
  },
  lng: readInitialLanguage(),
  fallbackLng: "sq",
  interpolation: {
    escapeValue: false,
  },
});

i18n.on("languageChanged", (language) => {
  if (language === "sq" || language === "en" || language === "sr" || language === "tr") {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(storageKey, language);
    }
    if (typeof document !== "undefined") {
      document.documentElement.lang = language;
    }
  }
});

if (typeof document !== "undefined") {
  document.documentElement.lang = readInitialLanguage();
}

export { i18n };
